document.addEventListener('DOMContentLoaded', function () {
    const section = document.getElementById('workforce-map');
    if (!section) return;
    if (!('IntersectionObserver' in window)) return;

    const mapCol       = section.querySelector('#map-orbit-col');
    const copyCol      = section.querySelector('.workforce-map-copy');
    const factsCols    = copyCol ? copyCol.querySelectorAll('.workforce-map-facts > div') : [];
    const dot          = section.querySelector('.map-orbit-dot');
    const label        = section.querySelector('.map-orbit-label');
    const ring         = section.querySelector('.map-orbit-ring');
    const orbitText    = section.querySelector('.map-orbit-text');
    const avatars      = section.querySelectorAll('.map-orbit-avatar');
    const panelDesktop = section.querySelector('.workforce-map-panel');
    const panelMobile  = section.querySelector('.workforce-map-panel-mobile');

    if (!mapCol || !copyCol || !ring) return;

    // Hidden-state classes (unchanged)
    mapCol.classList.add('map-anim-from-bottom');
    copyCol.classList.add('map-anim-from-bottom');
    factsCols.forEach((el) => el.classList.add('map-anim-from-bottom--child'));
    if (dot)   dot.classList.add('map-anim-fade');
    if (label) label.classList.add('map-anim-fade');
    ring.classList.add('map-anim-ring');
    if (orbitText) orbitText.classList.add('map-anim-fade');
    avatars.forEach((el) => el.classList.add('map-anim-avatar'));
    if (panelDesktop) panelDesktop.classList.add('map-anim-from-bottom--panel');
    if (panelMobile)  panelMobile.classList.add('map-anim-from-bottom--panel');

    let timeouts = [];
    function clearAllTimeouts() { timeouts.forEach(clearTimeout); timeouts = []; }

    function hideAll() {
        mapCol.classList.remove('is-visible');
        copyCol.classList.remove('is-visible');
        factsCols.forEach((el) => el.classList.remove('is-visible'));
        if (dot)   dot.classList.remove('is-visible');
        if (label) label.classList.remove('is-visible');
        ring.classList.remove('is-visible');
        if (orbitText) orbitText.classList.remove('is-visible');
        avatars.forEach((el) => {
            el.classList.remove('is-visible');
            el.style.animationDelay = '';
        });
        if (panelDesktop) panelDesktop.classList.remove('is-visible');
        if (panelMobile)  panelMobile.classList.remove('is-visible');
    }

    function showAll() {
        clearAllTimeouts();
        hideAll();

        // 1) Right column first
        timeouts.push(setTimeout(() => { copyCol.classList.add('is-visible'); }, 0));

        factsCols.forEach((el, i) => {
            const delay = 325 + i * 100; // 325ms, 425ms
            timeouts.push(setTimeout(() => { el.classList.add('is-visible'); }, delay));
        });

        // Start map just after last fact settles (~815ms total)
        const MAP_START = 820;
        timeouts.push(setTimeout(() => {
            mapCol.classList.add('is-visible');
            if (dot)   dot.classList.add('is-visible');
            if (label) label.classList.add('is-visible');
            ring.classList.add('is-visible');
        }, MAP_START));

        // Curved text later (keeps the same feel)
        if (orbitText) {
            timeouts.push(setTimeout(() => {
                orbitText.classList.add('is-visible');
            }, MAP_START + 430));
        }

        // Avatars + panel
        const AVATAR_BASE = MAP_START + 680;
        let earliest = Infinity;
        avatars.forEach((el, idx) => {
            const d = AVATAR_BASE + (Math.random() * 260) + idx * 80;
            if (d < earliest) earliest = d;
            timeouts.push(setTimeout(() => el.classList.add('is-visible'), d));
        });

        const panelDelay = (earliest !== Infinity ? earliest + 100 : MAP_START + 1000);
        if (panelDesktop) timeouts.push(setTimeout(() => panelDesktop.classList.add('is-visible'), panelDelay));
        if (panelMobile)  timeouts.push(setTimeout(() => panelMobile.classList.add('is-visible'),  panelDelay));
    }

    // ---- Hysteresis state machine -----------------------------------
    // states: 'idle' (ready to play), 'playing' (sequence running), 'visible' (finished, stay put)
    section.dataset.state = 'idle';

    const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting) {
            // Entered viewport (any overlap) → if not already visible/playing, start once
            if (section.dataset.state === 'idle') {
                section.dataset.state = 'playing';
                showAll();
                // When the longest scheduled thing finishes, mark as 'visible'
                const longest = 3000; // safe upper bound for our timers (ms)
                setTimeout(() => { if (section.dataset.state === 'playing') section.dataset.state = 'visible'; }, longest);
            }
            // If already 'playing' or 'visible', do nothing (avoid jitter)
        } else {
            // Fully out of view → reset so it can replay next time
            clearAllTimeouts();
            hideAll();
            section.dataset.state = 'idle';
        }
    }, {
        root: null,
        threshold: [0, 0.6], // we only care about "entered at all" and general visibility
        rootMargin: '0px 0px 0px 0px' // no early exits; leave only when fully out
    });

    observer.observe(section);
});